export default __webpack_public_path__ + "static/media/8a39886201a55573a1b3e7c7d5dd16fd.svg";